import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS, SECONDS_TO_MILLIS } from "lopermut"
import {
  CanonicalTopicsGroupedDataSchema,
  DataResponse,
  GetCanonicalTopicGroupedSchema,
} from "schema"
import z from "zod"

type Response = DataResponse<z.infer<typeof CanonicalTopicsGroupedDataSchema>> & {
  isGenerating: boolean
}

type Props = {
  query: z.infer<typeof GetCanonicalTopicGroupedSchema>
  enabled?: boolean
}

export const canonicalTopicsGroupedQuery = ({ query, enabled = true }: Props) => {
  return queryOptions({
    queryKey: ["canonical-topic", JSON.stringify(query)],
    staleTime: 10 * MINUTES_TO_MILLIS,
    queryFn: async () => {
      const response = await axios.get<Response>(`/insights/canonical-topics/grouped`, {
        params: query,
      })
      return {
        data: response.data.data.groups,
        groupedBy: query.groupedBy,
        isGenerating: response.data.data.generatingSnapshots,
      }
    },
    enabled,
    refetchInterval: (queryInstance) =>
      queryInstance.state.data?.isGenerating ? 30 * SECONDS_TO_MILLIS : false,
  })
}
